import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    buttonLabel: string;
    connectedTooltip: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the C2C Connections link in the ProjectTree */
            buttonLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectTreeC2CConnections.buttonLabel?c=1csunxuic6svc", defaultMessage: "C2C Connections" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip shown when Lightroom is connected */
            connectedTooltip: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectTreeC2CConnections.connectedTooltip?c=c0hj5es8753h", defaultMessage: "Your project is connected to an Adobe Lightroom account." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
